import { Routes } from '@angular/router';
import { AiChatFullComponent } from './pages/ai-chat-full/ai-chat-full.component';

export const ROUTES: Routes = [
  {
    path: 'ai-chat/:guid',
    component: AiChatFullComponent,
  },
];
